import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { AppService } from '../../services/prod/app.service'
import { I18nService, LgType } from '../../services/prod/i18n.service'
import { SetColorsService } from '../../services/set-colors.service'

@Component({
  selector: 'bmcore-newsletter-block',
  templateUrl: './bmcore-newsletter-block.component.html',
  styleUrls: ['./bmcore-newsletter-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreNewsletterBlockComponent implements OnInit {
  lg: LgType
  beatmakerId: number
  beatmakerName: string
  colorSettingsMode = false

  constructor(
    private appService: AppService,
    private i18nService: I18nService,
    private setColorsService: SetColorsService
  ) {}

  ngOnInit() {
    this.lg = this.i18nService.getLanguageForPage()
    this.getBeatmakerData()
    this.getColorSettingsMode()
  }

  getBeatmakerData() {
    this.appService.beatMakerDataSubject.subscribe(res => {
      if (res) {
        this.beatmakerId = res.beatmakerId
        this.beatmakerName = res.beatmakerName
      }
    })
  }

  getColorSettingsMode() {
    this.setColorsService.colorSettingsSubject.subscribe(res => {
      this.colorSettingsMode = res
    })
  }
}
